export const applyDefaultPort = select => {
    const group        = select.closest('[data-default-ports]');
    const defaultPorts = JSON.parse(group.dataset.defaultPorts);
    const port         = group.querySelector(`input[name="${CSS.escape(group.dataset.defaultPortInput)}"]`);
    const current      = port.value.trim();

    if (current !== '' && !Object.values(defaultPorts).map(String).includes(current)) {
        return;
    }

    port.value = defaultPorts[select.value];
};
